(function () {

    'use strict';

    angular.module('asys')
        .service('AngebotService', AngebotService);

    AngebotService.$inject = [
        '$injector',
        'lodash',
        'SchluesselWerteUtilsService',
        'MiscUtilsService',
        'MoneyUtilsService'
    ];
    function AngebotService($injector, _, SchluesselWerteUtilsService, MiscUtilsService, MoneyUtilsService) {
        var that = this;

        that.getBausteine = getBausteine;
        that.getGegenstaende = getGegenstaende;
        that.getGegenstaendeKeys = getGegenstaendeKeys;
        that.getBausteineKeys = getBausteineKeys;
        that.getBausteineKeysByProduktGruppe = getBausteineKeysByProduktGruppe;
        that.getBausteineByProduktGruppe = getBausteineByProduktGruppe;
        that.getProdukt = getProdukt;
        that.getBeitraegeGroupedByApiKey = getBeitraegeGroupedByApiKey;
        that.getApiKeyString = getApiKeyString;
        that.getMindestBeitraege = getMindestBeitraege;
        that.getGesamtbeitragZuZahlweise = getGesamtbeitragZuZahlweise;
        that.isAtLeastOneBausteinAktiv = isAtLeastOneBausteinAktiv;
        that.getProduktGruppen = getProduktGruppen;
        that.getBeitraegeGroupedByProduktGruppe = getBeitraegeGroupedByProduktGruppe;
        that.getBeitraegeTarifartenToBaustein = getBeitraegeTarifartenToBaustein;
        that.getHauptBaustein = getHauptBaustein;
        that.hatTarifrelevanteAenderungen = hatTarifrelevanteAenderungen;
        that.bereinigeAngebotFuerVergleich = bereinigeAngebotFuerVergleich;
        that.getKonditionen = getKonditionen;
        that.isKonditionVorhanden = isKonditionVorhanden;
        that.setVorversicherung = setVorversicherung;
        that.getVorversicherung = getVorversicherung;
        that.getVorversicherungen = getVorversicherungen;
        that.vorversicherungVorhanden = vorversicherungVorhanden;
        function getBausteine(obj, onlyActive, options) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                bausteine;

            options = options || {};

            options.regExp = options.regExp || /^baustein.*/;
            options.asObjectMap = options.asObjectMap || false;

            if (options.asObjectMap) {
                bausteine = {};
            } else {
                bausteine = [];
            }

            _.forEach(_.keys(obj), function (key) {
                if ((key.match(options.regExp) || []).length > 0 && (!onlyActive || onlyActive && BasisAngebotService.isBausteinAktiv(obj, key))) {
                    if (options.asObjectMap) {
                        bausteine[key] = obj[key];
                    } else {
                        bausteine.push(obj[key]);
                    }
                }
            });

            return bausteine;
        }
        function getGegenstaende(angebot, regExp) {
            var gegenstaende = {};

            regExp = regExp || /^angebotsgegenstand.*/;

            _.each(getGegenstaendeKeys(angebot, regExp), function (gegenstandKey) {
                gegenstaende[gegenstandKey] = _.get(angebot, gegenstandKey);
            });

            return gegenstaende;
        }
        function getGegenstaendeKeys(angebot, regExp) {
            regExp = regExp || /^angebotsgegenstand.*/;

            return MiscUtilsService.getPropertyKeysByEgExp(angebot, regExp);
        }
        function getBausteineKeys(object, regExp) {
            regExp = regExp || /^baustein.*/;

            return MiscUtilsService.getPropertyKeysByEgExp(object, regExp);
        }
        function getBausteineKeysByProduktGruppe(object, produktGruppe, onlyActive) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                bausteineKeys = getBausteineKeys(object),
                baustein;

            return bausteineKeys.filter(function (bausteinKey) {
                baustein = _.get(object, bausteinKey, {});

                if (_.get(baustein, 'produktGruppe') === produktGruppe) {
                    return !!(onlyActive && BasisAngebotService.isBausteinAktiv(object, bausteinKey) || !onlyActive);
                }
            });
        }
        function getBausteineByProduktGruppe(angebot, produktGruppe, onlyActive) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                bausteineKeys = getBausteineKeys(angebot),
                baustein,
                bausteineByProduktGruppe = {};

            _.each(bausteineKeys, function (bausteinKey) {
                baustein = _.get(angebot, bausteinKey, {});

                if (_.get(baustein, 'produktGruppe') === produktGruppe) {
                    if (onlyActive && BasisAngebotService.isBausteinAktiv(angebot, bausteinKey) || !onlyActive) {
                        bausteineByProduktGruppe[bausteinKey] = baustein;
                    }
                }
            });

            return bausteineByProduktGruppe;
        }
        function getProdukt(angebot, bausteinKey) {
            var produkte = [],
                produkt = {};

            if (MiscUtilsService.isEmpty(bausteinKey)) {
                _.each(getBausteineKeys(angebot), function (bausteinKey) {
                    produkt = _.get(angebot, bausteinKey + '.zasZapAnfrageErgebnis.produkt', _.get(angebot, bausteinKey + '.produkt'));
                    if (MiscUtilsService.isEmpty(produkt)) {
                        return true;
                    }

                    if (!_.includes(produkte, { wert: _.get(produkt, 'wert') })) {
                        produkte.push(produkt);
                    }
                });
            } else {
                produkte.push(_.get(angebot, bausteinKey + '.zasZapAnfrageErgebnis.produkt'));
            }
            return _.union(produkte);
        }
        function getBeitraegeGroupedByApiKey(obj, deckungsCode, produkt, tarifart) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                tarifrechnerergebnisZeilen = BasisAngebotService.getTarifrechnerergebnisZeilen(obj),
                beitraegeApiKeyMap = {},
                apiKey;

            if (tarifart) {
                tarifrechnerergebnisZeilen = _.filter(tarifrechnerergebnisZeilen, ['tarifart.wert', tarifart]);
            }

            beitraegeApiKeyMap = tarifrechnerergebnisZeilen.reduce(function (prevVal, curVal, i) {
                apiKey = [
                    curVal.apiKey,
                    'Prd',
                    curVal.produkt
                ].join(':');

                if (deckungsCode && deckungsCode === curVal.apiKey.split(':')[0] || !deckungsCode) {
                    if (produkt && curVal.produkt === produkt || !produkt) {
                        prevVal[apiKey] = curVal;
                    }
                }
                return prevVal;
            }, {});

            return beitraegeApiKeyMap;
        }
        function getApiKeyString(deckungscode, produkt, zahlweiseWert, angebot) {
            var zahlweise = zahlweiseWert || _.get(angebot, 'zahlungsinformationen.zahlweise.wert'),
                apiKey = [];

            if (MiscUtilsService.isAtLeastOneEmpty(deckungscode, zahlweise)) {
                return;
            }

            apiKey = [deckungscode, 'Zw', zahlweise];

            if (produkt) {
                apiKey.push('Prd', produkt);
            }

            return apiKey.join(':');
        }
        function getMindestBeitraege(angebot) {
            var beitraegeByApiKey = getBeitraegeGroupedByApiKey(angebot, 'ICISPLUS_PRD_MINDESTPRAEMIE'),
                apiKey;

            if (MiscUtilsService.isEmpty(beitraegeByApiKey)) {
                return null;
            }

            apiKey = getApiKeyString('ICISPLUS_PRD_MINDESTPRAEMIE', null, null, angebot);

            return _.pickBy(beitraegeByApiKey, function (value, key) {
                return _.startsWith(key, apiKey);
            });
        }
        function ermittleDifferenzausgleich(angebot, produktBeitraege, produktNr) {
            var beitraegeByApiKey = getBeitraegeGroupedByApiKey(angebot, 'ICISPLUS_PRD_MINDESTPRAEMIE', produktNr),
                mindespraemieByProduktBeitrag,
                gesamtbeitragByProdukt,
                mindespraemieByProdukt,
                apiKey,
                returnVal = {
                    brutto: MoneyUtilsService.toMoneyObject(0)
                };

            if (MiscUtilsService.isEmpty(beitraegeByApiKey)) {
                return returnVal;
            }

            apiKey = getApiKeyString('ICISPLUS_PRD_MINDESTPRAEMIE', produktNr, null, angebot);

            mindespraemieByProdukt = _.values(_.pickBy(beitraegeByApiKey, function (value, key) {
                return key === apiKey;
            }))[0];

            if (MiscUtilsService.isEmpty(mindespraemieByProdukt)) {
                return returnVal;
            }

            gesamtbeitragByProdukt = MoneyUtilsService.getAmount(MoneyUtilsService.summation.apply(null, _.flatten([produktBeitraege])));
            mindespraemieByProduktBeitrag = MoneyUtilsService.getAmount(mindespraemieByProdukt.brutto);
            returnVal.brutto = MoneyUtilsService.toMoneyObject(mindespraemieByProduktBeitrag - gesamtbeitragByProdukt <= 0 ? 0 : mindespraemieByProduktBeitrag - gesamtbeitragByProdukt);

            return returnVal;
        }
        function getGesamtbeitragZuZahlweise(angebot) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                beitraege = [],
                beitraegeByProdukt = {},
                mindestBeitragDifferenzausgleich,
                beitrag,
                tarifart;
            _.each(getBausteine(angebot, true, {
                asObjectMap: true
            }), function (baustein, bausteinKey) {
                beitrag = getBeitraegeTarifartenToBaustein(angebot, bausteinKey);

                tarifart = BasisAngebotService.getBausteinTarifart(angebot, angebot, bausteinKey);

                if (MiscUtilsService.isNotEmpty(beitrag[tarifart])) {
                    beitraege.push(beitrag[tarifart]);
                }
            });

            _.each(beitraege, function (beitrag) {
                if (beitraegeByProdukt[beitrag.produkt]) {
                    beitraegeByProdukt[beitrag.produkt].push(beitrag.brutto);
                } else {
                    beitraegeByProdukt[beitrag.produkt] = [beitrag.brutto];
                }
            });
            _.each(beitraegeByProdukt, function (produktBeitraege, produktNr) {
                mindestBeitragDifferenzausgleich = ermittleDifferenzausgleich(angebot, produktBeitraege, produktNr);
                beitraege.push(mindestBeitragDifferenzausgleich);
            });

            return MoneyUtilsService.summation.apply(null, _.map(beitraege, 'brutto'));
        }
        function ermittleBeitraegeZuProdukt(angebot, produktNr) {
            var beitraege = {},
                beitraegeOhneTarifart = [],
                beitraegeTarifart = {},
                beitrag;
            _.each(getBausteine(angebot, true, {
                asObjectMap: true
            }), function (baustein, bausteinKey) {
                if (produktNr !== _.get(baustein, 'produkt.wert')) {
                    return;
                }

                beitrag = getBeitraegeTarifartenToBaustein(angebot, bausteinKey);

                _.each(beitrag, function (beitragVal, tarifart) {
                    if (_.size(_.keys(beitrag)) === 1) {
                        beitraegeOhneTarifart.push(beitragVal);
                    } else {
                        if (beitraegeTarifart[tarifart]) {
                            beitraegeTarifart[tarifart].push(beitragVal);
                        } else {
                            beitraegeTarifart[tarifart] = [beitragVal];
                        }
                    }
                });
            });

            if (MiscUtilsService.isEmpty(beitraegeTarifart)) {
                return MiscUtilsService.isEmpty(beitraegeOhneTarifart) ? {} : MoneyUtilsService.summation.apply(null, _.map(beitraegeOhneTarifart, 'brutto'));

            } else {
                if (MiscUtilsService.isNotEmpty(beitraegeOhneTarifart)) {
                    _.each(beitraegeTarifart, function (beitraegeVal, tarifart) {
                        beitraegeTarifart[tarifart].push(beitraegeOhneTarifart);
                        beitraegeTarifart[tarifart] = _.flatten(beitraegeTarifart[tarifart]);
                    });
                }

                _.each(beitraegeTarifart, function (val, key) {
                    beitraege[key] = MoneyUtilsService.summation.apply(null, _.map(val, 'brutto'));
                });

                return beitraege;
            }
        }
        function isAtLeastOneBausteinAktiv(angebot, bausteineKeys) {
            if (MiscUtilsService.isEmpty(bausteineKeys)) {
                return false;
            }

            var booleanValues = bausteineKeys.map(function (bausteinKey) {
                return _.get(angebot, bausteinKey + '.aktiv', false);
            });

            return MiscUtilsService.isAtLeastOneTrue.apply(MiscUtilsService, booleanValues);
        }
        function getProduktGruppen(angebot, onlyActive, excludeProduktGruppen) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                aktiveProduktGruppen = [],
                AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                alleProduktGruppenSortiert = AngebotSpezifischService.getAlleProduktGruppenSortiert(),
                baustein,
                filteredProduktGruppen;

            if (!onlyActive) {
                return alleProduktGruppenSortiert;
            }

            _.each(getBausteineKeys(angebot), function (bausteinKey) {
                baustein = _.get(angebot, bausteinKey, {});

                if (onlyActive && BasisAngebotService.isBausteinAktiv(angebot, bausteinKey)) {
                    aktiveProduktGruppen.push(baustein.produktGruppe);
                }
            });

            aktiveProduktGruppen = _.uniq(aktiveProduktGruppen);

            if (MiscUtilsService.isNotEmpty(alleProduktGruppenSortiert)) {
                filteredProduktGruppen = _.filter(alleProduktGruppenSortiert, function (value) {
                    return !_.includes(excludeProduktGruppen, value) && _.includes(aktiveProduktGruppen, value);
                });
            } else {
                filteredProduktGruppen = _.filter(aktiveProduktGruppen, function (value) {
                    return !_.includes(excludeProduktGruppen, value);
                });
            }

            return _.uniq(filteredProduktGruppen);
        }
        function getBeitraegeGroupedByProduktGruppe(angebot, options) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                beitraegeByProduktGruppe = {},
                AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                bausteineKeys = [],
                hauptbaustein,
                mindestBeitragBausteinKey,
                bausteineSortiert = [],
                mindestBeitrag = getMindestBeitraege(angebot),
                mindestBeitragVorhanden,
                infos = {},
                obj,
                beitrag,
                beitraegeZuProdukt,
                baustein;

            function addEntryToBeitraegeGroupedByProduktGruppe(preparedBeitragsBaustein, produktGruppe, bausteinKey) {
                if (MiscUtilsService.isEmpty(beitraegeByProduktGruppe[produktGruppe])) {
                    beitraegeByProduktGruppe[produktGruppe] = options.convertToArray ? [] : {};
                }

                if (options.initLoading) {
                    if (_.get(preparedBeitragsBaustein, 'baustein.aktiv')) {
                        preparedBeitragsBaustein.beitrag = {};
                    } else {
                        preparedBeitragsBaustein.beitrag = null;
                    }
                }
                if (options.convertToArray) {
                    beitraegeByProduktGruppe[produktGruppe].push(preparedBeitragsBaustein);
                } else {
                    beitraegeByProduktGruppe[produktGruppe][bausteinKey] = preparedBeitragsBaustein;
                }
            }

            options = options || {};
            options.onlyActive = _.isUndefined(options.onlyActive) ? true : options.onlyActive;

            bausteineKeys = getBausteineKeys(angebot);
            _.each(bausteineKeys, function (bausteinKey) {
                baustein = _.get(angebot, bausteinKey);
                if (options.onlyActive && !BasisAngebotService.isBausteinAktiv(angebot, bausteinKey)) {
                    baustein = null;
                    return;
                }

                beitrag = getBeitraegeTarifartenToBaustein(angebot, bausteinKey);
                infos = AngebotSpezifischService.getBeitraegeZusatzInfosToBaustein(angebot, baustein, bausteinKey, options);

                obj = {
                    baustein: baustein,
                    bausteinKey: bausteinKey,
                    beitrag: beitrag,
                    infos: infos
                };

                if (baustein && (MiscUtilsService.isNotEmpty(beitrag) || options.initLoading)) {
                    addEntryToBeitraegeGroupedByProduktGruppe(obj, baustein.produktGruppe, bausteinKey);
                }
            });
            if (mindestBeitrag) {
                _.each(mindestBeitrag, function (value) {
                    mindestBeitragBausteinKey = 'mindestBeitrag' + value.produkt;
                    mindestBeitragVorhanden = false;
                    beitrag = {};
                    hauptbaustein = getHauptBaustein(angebot, value.produkt) || {};
                    beitraegeZuProdukt = ermittleBeitraegeZuProdukt(angebot, value.produkt);

                    if (MoneyUtilsService.isMoneyObject(beitraegeZuProdukt)) {
                        beitrag = ermittleDifferenzausgleich(angebot, beitraegeZuProdukt, value.produkt);

                        mindestBeitragVorhanden = MoneyUtilsService.getAmount(beitrag.brutto) > 0;
                    } else {
                        _.each(_.keys(beitraegeZuProdukt), function (tarifart) {
                            beitrag[tarifart] = ermittleDifferenzausgleich(angebot, beitraegeZuProdukt[tarifart], value.produkt);
                        });

                        _.each(beitrag, function (beitragVal) {
                            if (MoneyUtilsService.getAmount(_.get(beitragVal, 'brutto')) > 0) {
                                mindestBeitragVorhanden = true;
                                return false;
                            }
                        });
                    }

                    if (!mindestBeitragVorhanden) {
                        beitrag = null;
                    }

                    obj = {
                        aktiv: !!mindestBeitragVorhanden,
                        baustein: {
                            aktiv: true,
                            deckungscode: SchluesselWerteUtilsService.create('DECKUNGSCODE', 'ICISPLUS_PRD_DIFFAUSGLEICH'),
                            produktGruppe: 'MINDESTBEITRAG',
                            moeglicheTarifarten: hauptbaustein.moeglicheTarifarten,
                            tarifartModellierung: hauptbaustein.tarifartModellierung
                        },
                        bausteinKey: mindestBeitragBausteinKey,
                        beitrag: beitrag,
                        infos: {
                            label: {
                                deckung: 'Differenzausgleich wegen Unterschreitung des Mindestbeitrags'
                            }
                        }
                    };

                    addEntryToBeitraegeGroupedByProduktGruppe(obj, 'MINDESTBEITRAG', mindestBeitragBausteinKey);
                });
            }
            if (options.convertToArray) {
                bausteineSortiert = AngebotSpezifischService.getAlleBausteineSortiertByProduktGruppe();
                _.forOwn(beitraegeByProduktGruppe, function (bausteine, produktGruppe) {
                    beitraegeByProduktGruppe[produktGruppe] = _.sortBy(bausteine, function (baustein) {
                        if (!bausteineSortiert[produktGruppe]) {
                            return 0;
                        }

                        var index = _.indexOf(bausteineSortiert[produktGruppe], baustein.bausteinKey);
                        return (index === -1) ? bausteineSortiert[produktGruppe].length : index;
                    });
                });
            }

            return beitraegeByProduktGruppe;
        }
        function getBeitraegeTarifartenToBaustein(angebot, bausteinKey) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                beitrag = {},
                deckungscode = BasisAngebotService.getDeckungscode(angebot, bausteinKey),
                beitraegeByApiKey,
                moeglicheTarifarten = BasisAngebotService.getMoeglicheTarifarten(angebot, bausteinKey),
                baustein = _.get(angebot, bausteinKey),
                produkt = _.get(baustein, 'produkt.wert'),
                beitragApiKey,
                AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (moeglicheTarifarten.length > 1) {
                _.each(moeglicheTarifarten, function (tarifart) {
                    beitraegeByApiKey = getBeitraegeGroupedByApiKey(angebot, null, null, tarifart.typ === 'TARIFART' ? tarifart.wert : null);

                    if (angular.isFunction(AngebotSpezifischService.getDeckungscode)) {
                        deckungscode = AngebotSpezifischService.getDeckungscode(angebot, bausteinKey, tarifart.wert);
                    }

                    beitragApiKey = beitraegeByApiKey[getApiKeyString(deckungscode, produkt, null, angebot)];

                    if (beitragApiKey) {
                        beitrag[tarifart.wert] = beitragApiKey;
                    }
                });
            } else {
                beitraegeByApiKey = getBeitraegeGroupedByApiKey(angebot),
                beitragApiKey = beitraegeByApiKey[getApiKeyString(deckungscode, produkt, null, angebot)];

                if (beitragApiKey) {
                    beitrag[baustein.tarifartModellierung.wert] = beitragApiKey;
                }
            }

            return beitrag;
        }
        function getHauptBaustein(angebot, produktNr) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service');

            if (_.isFunction(AngebotSpezifischService.getHauptBaustein)) {
                return AngebotSpezifischService.getHauptBaustein(angebot, produktNr);
            }
        }
        function hatTarifrelevanteAenderungen(angebot, compareAngebot, options) {
            return false;
        }
        function bereinigeAngebotFuerVergleich(angebot, options) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                AngebotSpezifischService = BasisAngebotService.getDIReference(BasisAngebotService.getAngebotSpezifischNamePrefix(angebot) + 'Service'),
                vorschaedenDetails;

            options = options || {};

            MiscUtilsService.removeProperty(angebot, 'ergebnisLetzteBerechnung');
            MiscUtilsService.removeProperty(angebot, 'zasZapAnfrageErgebnis', true);
            if (options.bereinigeInaktiveBausteine !== false) {
                BasisAngebotService.leereInaktiveBausteine(angebot);
            }
            vorschaedenDetails = _.get(angebot, 'vorschaeden.details');
            if (MiscUtilsService.isNotEmpty(vorschaedenDetails) && _.size(vorschaedenDetails) > 1) {
                _.set(angebot, 'vorschaeden.details', _.sortBy(vorschaedenDetails, ['typ.wert']));
            }

            if (angular.isFunction(AngebotSpezifischService.bereinigeAngebotFuerVergleich)) {
                AngebotSpezifischService.bereinigeAngebotFuerVergleich(angebot, options);
            }
        }
        function getKonditionen(angebot) {
            return _.get(angebot, 'konditionen');
        }
        function isKonditionVorhanden(angebot, konditionscodeId) {
            return _.findIndex(_.get(angebot, 'konditionen'), ['konditionscode.id', konditionscodeId]) !== -1;
        }
        function setVorversicherung(angebot, vorversicherung, bausteinKey, options, produktWert) {
            var BasisAngebotService = $injector.get('BasisAngebotService'),
                produkt,
                vorversicherungen = _.get(angebot, 'vorversicherungen'),
                vorversicherungZuProdukt,
                idx,
                beiWemBestandVorversicherung;

            produkt = produktWert ? {
                typ: 'PRODUKT',
                wert: produktWert
            } : getProdukt(angebot, bausteinKey)[0];

            vorversicherungZuProdukt = _.merge({}, {
                produkt: produkt
            }, vorversicherung);

            if (MiscUtilsService.isAtLeastOneEmpty(angebot, bausteinKey, produkt)) {
                return;
            }

            if (options.version === 'EINE_VORVERSICHERUNG') {
                _.set(angebot, 'vorversicherung', vorversicherung);
                return;
            }

            idx = _.findIndex(vorversicherungen, {
                produkt: {
                    wert: _.get(produkt, 'wert')
                }
            });

            if (MiscUtilsService.isNotEmpty(vorversicherung) && vorversicherung.vorhanden) {
                if (MiscUtilsService.isNotEmpty(vorversicherung.unternehmenVersicherungsscheinnummer)) {
                    beiWemBestandVorversicherung = BasisAngebotService.getConstant('vorversicherungsarten').unternehmen.wert;
                } else if (MiscUtilsService.isNotEmpty(vorversicherung.fremdgesellschaftVersicherungsscheinnummer)) {
                    beiWemBestandVorversicherung = BasisAngebotService.getConstant('vorversicherungsarten').fremdversicherung.wert;
                }

                if (beiWemBestandVorversicherung) {
                    _.set(vorversicherung, 'beiWemBestandVorversicherung', beiWemBestandVorversicherung);
                }
            } else if (MiscUtilsService.isNotEmpty(vorversicherung) && vorversicherung.vorhanden === false) {
                _.set(vorversicherung, 'beiWemBestandVorversicherung', null);
            }
            if (idx > -1) {
                if (MiscUtilsService.isEmpty(vorversicherung)) {
                    vorversicherungen.splice(idx, 1);
                } else {
                    vorversicherungen.splice(idx, 1, vorversicherungZuProdukt);
                }
            } else if (MiscUtilsService.isNotEmpty(vorversicherung)) {
                if (!vorversicherungen) {
                    _.set(angebot, 'vorversicherungen', [vorversicherungZuProdukt]);
                } else {
                    vorversicherungen.push(vorversicherungZuProdukt);
                }
            }
        }
        function getVorversicherung(angebot, bausteinKey, options, produktWert) {
            var produkt,
                vorversicherung;

            options = options || {};

            if (MiscUtilsService.isAtLeastOneEmpty(angebot)) {
                return {};
            }

            if (_.includes(['EINE_VORVERSICHERUNG'], options.version)) {
                vorversicherung = _.filter([_.get(angebot, 'vorversicherung')], options.onlyActive ? ['vorhanden', true] : null)[0];
            }

            if (options.version === 'EINE_VORVERSICHERUNG') {
                return vorversicherung || {};
            }

            if (MiscUtilsService.isAtLeastOneEmpty(bausteinKey)) {
                return {};
            }

            produkt = produktWert ? {
                typ: 'PRODUKT',
                wert: produktWert
            } : getProdukt(angebot, bausteinKey)[0];

            return _.filter([_.find(_.get(angebot, 'vorversicherungen'), {
                produkt: {
                    wert: _.get(produkt, 'wert')
                }
            })], options.onlyActive ? ['vorhanden', true] : null)[0] || vorversicherung;
        }
        function getVorversicherungen(angebot) {
            var vorversicherungen = [];

            if (_.get(angebot, 'vorversicherung.vorhanden')) {
                vorversicherungen.push(angebot.vorversicherung);
            } else {
                vorversicherungen.push(_.filter(_.get(angebot, 'vorversicherungen'), ['vorhanden', true]));
            }

            return _.flatten(vorversicherungen);
        }
        function vorversicherungVorhanden(angebot) {
            return !!(
                _.get(angebot, 'vorversicherung.vorhanden') ||
                _.filter(_.get(angebot, 'vorversicherungen'), ['vorhanden', true]).length
            );
        }
    }

})();
